import { Divider } from '@mui/material'
import React from 'react'

function Header() {
  return (
    <>
      <br />
      <h4 className='text-light'> Hi! I'm</h4>
      <h1> Francisco Peretti </h1>
      <h4 className='text-light'> and this is my portfolio </h4>
      <br />
    </>
  )
}

export default Header